export default "__VITE_ASSET__VBr8sVPN__"